const embedBlockSelector = '.embedBlock';
const embedElementSelectors = 'iframe, object, embed';

const wrapEmbed = (embed) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('iframe-wrap');

    embed.parentNode.insertBefore(wrapper, embed);
    wrapper.appendChild(embed);
}

document.addEventListener("DOMContentLoaded", () => {
    const embedBlocks = document.querySelectorAll(embedBlockSelector);
    
    if(!embedBlocks) {
        return;
    }
    
    embedBlocks.forEach((block) => {
        const embedElements = block.querySelectorAll(embedElementSelectors);

        if(!embedElements) {
            return;
        }
        
        embedElements.forEach((embed) => {
            wrapEmbed(embed);
        });
    });
});
